import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';

// Import pages
import Dashboard from './pages/Dashboard';
import Providers from './pages/Providers';
import Zones from './pages/Zones';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Security from './pages/Security';
import Backup from './pages/Backup';

// Import components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';

// Import hooks
import { useAuth } from './hooks/useAuth';

// Import theme context
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <ThemeProvider>
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
          <LoadingSpinner size="lg" />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-gray-50 dark:bg-gray-900"
      >
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/providers" element={<Providers />} />
                    <Route path="/zones" element={<Zones />} />
                    <Route path="/security" element={<Security />} />
                    <Route path="/backup" element={<Backup />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route
                      path="*"
                      element={
                        <div className="flex flex-col items-center justify-center min-h-96">
                          <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                          <p className="text-gray-600">Page not found</p>
                        </div>
                      }
                    />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </motion.div>
    </ThemeProvider>
  );
}

export default App;
